import {useLazyQuery} from '@apollo/client/react';
import {SeedQuestion, SeedQuestionStatus} from '@cp/model';
import {LIST_SEED_QUESTIONS} from '../sharedQueries';

export interface ListSeedQuestionsVariables {
  moduleId: string;
  topic?: string;
  status?: SeedQuestionStatus;
  limit?: number;
  offset?: number;
}

export function useListSeedQuestions() {
  const [fetchSeedQuestionsGql, {data, loading, error, refetch, called}] = useLazyQuery<
    {listSeedQuestions: SeedQuestion[]},
    ListSeedQuestionsVariables
  >(LIST_SEED_QUESTIONS, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
  });

  const fetchSeedQuestions = (variables: ListSeedQuestionsVariables) => {
    return fetchSeedQuestionsGql({
      variables,
    });
  };

  const refetchSeedQuestions = (variables: ListSeedQuestionsVariables) => {
    if (called && refetch) {
      return refetch(variables);
    }
    return fetchSeedQuestionsGql({
      variables,
    });
  };

  return {
    seedQuestions: data?.listSeedQuestions || [],
    loading,
    error,
    fetchSeedQuestions,
    refetchSeedQuestions,
    refetch,
  };
}
